import React from 'react'

const BubbleComp = ({ elem, text = 'Demo text', aling = 'right' }) => {

    const showBubble = (e) => {
        let chNodes = e.currentTarget.previousSibling
        chNodes.style.opacity = 1;
    }

    const hideBubble = (e) => {
        let chNodes = e.currentTarget.previousSibling
        chNodes.style.opacity = 0;
    }

    const clName = aling === 'left' ? 'thought left-bubble' : 'thought';

    return (
        <div>
            <p className={clName}>{text}!</p>
            <div onMouseEnter={(item) => showBubble(item)} onMouseLeave={(item) => hideBubble(item)} >
                {elem}
            </div>
        </div>
    )
}

export default BubbleComp;


// WEBPACK FOOTER //
// ./src/components/bubbleComp.js